<template>
	<div class="lw">
		<div class="lw__elm">
			<!-- ///////////// -->
			<!-- LABEL -->
			<div class="lw__elm-label">Вход</div>

			<!-- //////////////// -->
			<!-- LOGIN FORM -->
			<LoginForm />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import LoginForm from "@/components/login/LoginForm.vue";

@Options({
	components: { LoginForm },
})
export default class LoginView extends Vue {}
</script>

<style scoped lang="scss">
.lw {
	display: flex;
	justify-content: center;
	user-select: none;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-label {
		padding: 24px 0 12px;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm-label {
			font-size: 16px;
		}
		&__elm {
			padding: 0 12px;
			min-width: 100px;
		}
	}
}
</style>
